export const parseFloatOrZero = (value: string | undefined) => {
  if (value) {
    const parsedValue = parseFloat(value);
    if (!Number.isNaN(parsedValue)) {
      return parsedValue;
    }
  }

  return 0;
};
